import React from 'react'
import styled from 'styled-components'
import { ExpandMore } from 'svgIcons'
import useDropdown from '@app.modules/hooks/useDropdown'
import CategoryDropdown from './CategoryDropdown'
import JobTypeDropdown from './JobTypeDropdown'

const DutyListHeader: React.FC = () => {
  const [categoryRef, categoryOpen, toggleCategory] = useDropdown()
  const [jobTypeRef, jobTypeOpen, toggleJobType] = useDropdown()

  return (
    <StyledWrapper>
      <StyledHeaderTitle basis={20}>기업명</StyledHeaderTitle>
      <StyledHeaderTitle basis={34}>
        <div
          className="dropdown-btn"
          ref={categoryRef}
          onClick={toggleCategory}
        >
          직무
          <ExpandMore className="filter-icon" fontSize="inherit" />
        </div>
        {categoryOpen && <CategoryDropdown />}
      </StyledHeaderTitle>
      <StyledHeaderTitle basis={7}>
        <div className="dropdown-btn" ref={jobTypeRef} onClick={toggleJobType}>
          형태
          <ExpandMore className="filter-icon" fontSize="inherit" />
        </div>
        {jobTypeOpen && <JobTypeDropdown />}
      </StyledHeaderTitle>
      <StyledHeaderTitle basis={9}>마감일</StyledHeaderTitle>
      <StyledHeaderTitle basis={8} className="question">
        문항
      </StyledHeaderTitle>
      <StyledHeaderTitle basis={7}>작성자 수</StyledHeaderTitle>
    </StyledWrapper>
  )
}

export default DutyListHeader

const StyledWrapper = styled.div`
  font-size: 12px;
  color: #333333;
  font-weight: 500;
  display: flex;
  align-items: center;
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  height: 40px;
  text-align: center;

  .dropdown-btn {
    cursor: pointer;
    display: flex;
    gap: 7px;
    justify-content: center;
    align-items: center;
    .filter-icon {
      width: 10px;
      height: 10px;
      margin-top: 1px;
    }
  }
`

const StyledHeaderTitle = styled.div<{ basis: number }>`
  position: relative;
  flex-basis: ${({ basis }) => basis}%;
`
